var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AnalyticsTemplate',{attrs:{"page-title":"流量统计","chart-type":"traffic"}})
}
var staticRenderFns = []

export { render, staticRenderFns }